/**
 * 예약 userId.
 *
 * `@`로 네임스페이스가 갈려 있어(`life-timeline.com/@junho` vs `life-timeline.com/settings`)
 * 앱 경로와 **충돌하지는 않는다.** 그런데도 막는 이유는 혼동 때문이다 —
 * `@anonymous`나 `@admin`이 있으면 공식 계정으로 오해받는다.
 *
 * 클라이언트 입력 검증과 서버 검증이 **같은 목록**을 봐야 해서 shared에 둔다.
 * 한쪽만 고치면 화면에선 되는데 서버가 막는 상황이 된다.
 */

export const RESERVED_USER_IDS: ReadonlySet<string> = new Set([
  // 앱 경로와 같은 이름
  'anonymous',
  'me',
  'settings',
  'search',
  'about',
  'login',
  'logout',
  'signup',
  'new',
  'edit',
  // 공식으로 오해받을 이름
  'admin',
  'administrator',
  'official',
  'support',
  'help',
  'team',
  'staff',
  'lifetimeline',
  'oneby',
  // 기술적으로 헷갈리는 값
  'api',
  'www',
  'null',
  'undefined',
  'true',
  'false',
  'data',
  'assets',
  'static',
]);

export function isReservedUserId(userId: string): boolean {
  return RESERVED_USER_IDS.has(userId.toLowerCase());
}

/**
 * userId 형식 규칙.
 *
 * 소문자만 허용하는 이유: URL은 대소문자를 구분하는데 사람은 구분해서 기억하지
 * 않는다. `@Junho`와 `@junho`가 다른 사람이면 사칭의 통로가 된다.
 */
export const USER_ID_PATTERN = /^[a-z][a-z0-9_-]{2,19}$/;
export const USER_ID_MIN_LENGTH = 3;
export const USER_ID_MAX_LENGTH = 20;

export function isValidUserIdFormat(userId: string): boolean {
  return USER_ID_PATTERN.test(userId);
}
